import { MIN_PASSWORD_LENGTH, PasswordStrength } from '../constants';

export const calculatePasswordStrength = (password: string): PasswordStrength => {
    let strength = 0;
    if (password.length >= MIN_PASSWORD_LENGTH) strength++;
    if (password.length >= 12) strength++;
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) strength++;
    if (/\d/.test(password)) strength++;
    if (/[^a-zA-Z\d]/.test(password)) strength++;

    if (strength <= 2) return 'weak';
    if (strength <= 4) return 'medium';
    return 'strong';
};

export const getStrengthColor = (strength: PasswordStrength | null) => {
    if (!strength) return 'grey';
    if (strength === 'weak') return 'error';
    if (strength === 'medium') return 'warning';
    return 'success';
};

export const getStrengthValue = (strength: PasswordStrength | null) => {
    if (!strength) return 0;
    if (strength === 'weak') return 33;
    if (strength === 'medium') return 66;
    return 100;
};
